import axios from 'axios';
import { Toast } from 'vant'; // 我用的mint的框架来弹出我的错误返回 大家可以用别的提示
const Qs = require('qs');

// 默认超时设置
axios.defaults.timeout = 50000;

// 相对路径设置
axios.defaults.baseURL = process.env.VUE_APP_API_PATH;

//http request 拦截器
axios.interceptors.request.use(
    config => {
        Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            // overlay : true,
            message: "加载中"
        });
        // 设置参数格式
        if (!config.headers['Content-Type']) {
            config.headers = {
                'Content-Type': 'application/json;charset=UTF-8',
            };
        }
        if (localStorage.getItem('lbs-token') && !config.url.includes('auth/clientToken')) {
            config.headers.authorization = localStorage.getItem('lbs-token')
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);
//http response 拦截器
axios.interceptors.response.use(
    response => {
        Toast.clear({
            clearAll: true
        });
        //一些统一code的返回处理
        return response;
    },
    error => {
        if(error.response.data && error.response.data.code==401){
          location.replace('/')
        }
        return Promise.reject(error)
    }
);
/**
 * 封装get方法
 * @param url
 * @param params
 * @returns {Promise}
 */
export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
                params: JSON.parse(JSON.stringify(params)),
            })
            .then(response => {
                console.log('response', response)
                if (response.status === 200) {
                    //返回成功处理  这里传的啥 后续调用的时候 res就是啥
                    resolve(response.data); //我们后台所有数据都是放在返回的data里所以这里统一处理了
                } else {
                    //错误处理
                    Toast(response.data.msg)
                }
            })
            .catch(err => {
                reject(err);
                let message = '请求失败！请检查网络';
                if (err.response) message = err.response.data.message;
                Toast(message)
            })
    })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.post(url, data)
            .then(response => {
                if (response.data.code !== 1001) {
                    resolve(response.data);
                } else {
                    if (response.data.msg) {
                        Toast(response.data.msg)
                    }
                }
            }, err => {
              console.log('error123',err)
                reject(err);
                let message = '请求失败！请检查网络';
                if (err.response) message = err.response.data.message;
                Toast(message)
            })
    })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.patch(url, data)
            .then(response => {
                if (response.data.code === 200) {
                    resolve(response.data.data);
                } else {
                    Toast(response.data.msg)
                }
            }, err => {

                reject(err);
                let message = '请求失败！请检查网络';
                if (err.response) message = err.response.data.message;
                Toast(message)
            })
    })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.put(url, data)
            .then(response => {
                if (response.data.code === 200) {
                    resolve(response.data.data);
                } else {
                    Toast(response.data.msg)
                }
            }, err => {
                reject(err);
                let message = '请求失败！请检查网络';
                if (err.response) message = err.response.data.message;
                Toast(message)
            })
    })
}

export function del(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.delete(url, data)
            .then(response => {
                if (response.data.code === 200) {
                    resolve(response.data.data);
                } else {
                    Toast(response.data.msg)
                }
            }, err => {
                reject(err);
                let message = '请求失败！请检查网络';
                if (err.response) message = err.response.data.message;
                Toast(message)
            })
    })
}
